import React, { useEffect, useRef } from 'react';
import './WhyVTD.css';

const SVGIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" width="40" height="40"
    fill="none" stroke="#D4AF37" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
    aria-hidden="true" {...props} />
);

const ClockIcon  = () => <SVGIcon><circle cx="22" cy="22" r="14"/><line x1="22" y1="22" x2="22" y2="12"/><line x1="22" y1="22" x2="29" y2="22"/><line x1="10" y1="10" x2="34" y2="34" strokeOpacity="0.5"/></SVGIcon>;
const BadgeIcon  = () => <SVGIcon><path d="M22 6 L25 15 L35 15 L27 21 L30 31 L22 25 L14 31 L17 21 L9 15 L19 15 Z"/><circle cx="22" cy="22" r="4" fill="rgba(212,175,55,0.15)" stroke="none"/></SVGIcon>;
const JourneyIcon = () => <SVGIcon><circle cx="10" cy="34" r="3" fill="#D4AF37" stroke="none"/><circle cx="22" cy="22" r="3" fill="#D4AF37" stroke="none"/><circle cx="34" cy="10" r="3" fill="#D4AF37" stroke="none"/><path d="M10 34 Q16 28 22 22 Q28 16 34 10" strokeDasharray="4 3"/><line x1="30" y1="10" x2="38" y2="10"/><line x1="34" y1="6" x2="34" y2="14"/></SVGIcon>;
const LeafIcon   = () => <SVGIcon><path d="M22 36 Q8 26 8 14 Q8 4 22 4 Q36 4 36 14 Q36 26 22 36 Z" fill="rgba(212,175,55,0.08)"/><line x1="22" y1="36" x2="22" y2="14"/><path d="M22 28 Q14 22 12 14"/><path d="M22 28 Q30 22 32 14"/></SVGIcon>;
const PriceIcon  = () => <SVGIcon><path d="M10 8 L30 8 Q36 8 36 14 L36 26 Q36 32 30 32 L24 32 L10 18 Z" fill="rgba(212,175,55,0.06)"/><circle cx="29" cy="15" r="3" fill="rgba(212,175,55,0.2)"/><line x1="14" y1="18" x2="28" y2="18"/><line x1="14" y1="24" x2="24" y2="24"/></SVGIcon>;
const ShieldIcon = () => <SVGIcon><path d="M22 4 L36 9 L36 22 Q36 33 22 40 Q8 33 8 22 L8 9 Z" fill="rgba(212,175,55,0.07)"/><path d="M15 22 L20 27 L29 17"/></SVGIcon>;

const CARDS = [
  { Icon: ClockIcon,   title: 'No Per-Minute Billing',   vtd: 'Fixed flat pricing — consult without a clock ticking',          others: 'Per-minute charges pressure you to rush' },
  { Icon: BadgeIcon,   title: 'VTD Certified Only',      vtd: 'Every astrologer is VTD trained & verified',                    others: 'Random, unverified astrologers' },
  { Icon: JourneyIcon, title: 'Visual Life Journey',     vtd: 'Your entire life mapped as a visual journey you can see',       others: 'Vague predictions with no clear roadmap' },
  { Icon: LeafIcon,    title: 'Remedies by Founder',     vtd: 'Every remedy personally handled by Tilak',                      others: 'Generic remedies anyone can find online' },
  { Icon: PriceIcon,   title: 'Fixed Transparent Price', vtd: 'Price shown upfront — no hidden charges',                      others: 'Hidden fees revealed after your session' },
  { Icon: ShieldIcon,  title: 'No Random Astrologers',   vtd: 'Same trusted experts every time',                              others: 'Get whoever is available that minute' },
];

const WhyVTD = () => {
  const gridRef = useRef(null);

  useEffect(() => {
    const cards = gridRef.current?.querySelectorAll('.why-card');
    if (!cards?.length) return;
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('why-card--visible'); observer.unobserve(e.target); }
      }),
      { threshold: 0.15 }
    );
    cards.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section className="why-vtd" id="why-vtd" aria-label="Why choose VTD Astrology">
      <div className="why-vtd__inner">
        <div className="why-vtd__header">
          <p className="section-eyebrow">Our Difference</p>
          <h2 className="section-title">Why VTD is Different</h2>
          <p className="section-sub">Not just astrology — a new standard of service</p>
          <div className="gold-divider" />
        </div>

        <div className="why-vtd__grid" ref={gridRef}>
          {CARDS.map((card, i) => (
            <div key={card.title} className="why-card"
              style={{ transitionDelay: `${(i % 3) * 100}ms` }}>
              <div className="why-card__icon"><card.Icon /></div>
              <h3 className="why-card__title">{card.title}</h3>
              <div className="why-card__row why-card__row--vtd">
                <span className="why-card__badge">VTD</span>
                <p className="why-card__text">{card.vtd}</p>
              </div>
              <div className="why-card__row why-card__row--others">
                <span className="why-card__badge why-card__badge--others">Others</span>
                <p className="why-card__text why-card__text--strike">{card.others}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyVTD;
